import { render, staticRenderFns } from "./CampaignDuration.vue?vue&type=template&id=3a876df8&"
import script from "./CampaignDuration.vue?vue&type=script&lang=js&"
export * from "./CampaignDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a876df8')) {
      api.createRecord('3a876df8', component.options)
    } else {
      api.reload('3a876df8', component.options)
    }
    module.hot.accept("./CampaignDuration.vue?vue&type=template&id=3a876df8&", function () {
      api.rerender('3a876df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/expiration-campaign/components/CampaignDuration.vue"
export default component.exports